/* eslint-disable import/prefer-default-export */
/**
 * @param {Object} e onChange event
 * @param {Object} formValues formValues state object
 * @param {Function} setFormValues formValues state setter function
 * @param {boolean} numberCast Cast the value to a number
 */
export const handleInputChange = (e, formValues, setFormValues, numberCast = false) => {
  const { name } = e.target;
  let { value } = e.target;
  if (name === '') {
    throw Error('No name set on Input');
  }

  if (numberCast) {
    value = Number(value);
  }

  setFormValues({
    ...formValues,
    [name]: value,
  });
};

export const handleCheckboxChange = (e, formValues, setFormValues) => {
  const { name } = e.target;
  let { checked } = e.target;
  if (name === '') {
    throw Error('No name set on Input');
  }

  setFormValues({
    ...formValues,
    [name]: checked,
  });
};


export const handleDateInputChange = (newValue, setFormValues, name) => {
  setFormValues(prevState => (
    {
      ...prevState,
      [name]: newValue
    }
  ))
}
